import ax from '../axios'
import { ID, IHomework, IHomeworkVoiceRecord } from "../../constants";
import {API_URL} from "../index";

const HOMEWORK_URL = API_URL.EDUCATION_MODULE.replace(/([^:]\/)\/+/g, '$1') + '/homework'

const getHomeworkVoiceRecords = async (id: ID): Promise<IHomeworkVoiceRecord[]> => {
    const result = await ax.get<any, {status: boolean, data: IHomeworkVoiceRecord[]}>(`${HOMEWORK_URL}/${id}/voice-records`)
    if (!result.status) throw new Error('Ses kayıtları yüklenemedi')
    return result.data.map(record => ({
        ...record,
        url: `${HOMEWORK_URL}/${id}/voice-records/${record.id}/audio`,
    }))
}

const getHomeworkVoiceRecordAudio = (url: string): Promise<Blob> =>
    ax.get<any, Blob>(url, {responseType: 'blob', timeout: 60000})

const getHomeworks = async (query: string) => {
    try {
        return await ax.get(`${HOMEWORK_URL}?${query}`)
    } catch (error: any) {
        // Older education APIs return this domain error for an empty homework list.
        if (error.status === 404 && error.data?.errorCode === 16001 && error.data?.errorName === 'NotFound') {
            return {status: true, code: 200, data: []}
        }
        throw error
    }
}

const getHomeworkById = (id: ID) => {
    return ax.get(`${HOMEWORK_URL}/${id}`)
}

const createHomework = (baseModel: IHomework) => {
    delete baseModel.id
    return ax.post(HOMEWORK_URL, baseModel)
}

const updateHomework = (baseModel: IHomework) => {
    const id = baseModel.id
    delete baseModel.id
    return ax.put(`${HOMEWORK_URL}/${id}`, baseModel)
}

const deleteHomework = (id: ID) => {
    return ax.delete(`${HOMEWORK_URL}/${id}`)
}

export {
    getHomeworkVoiceRecords,
    getHomeworkVoiceRecordAudio,
    createHomework,
    deleteHomework,
    getHomeworks,
    getHomeworkById,
    updateHomework,
}
